import { render } from "./StampItemDetails.vue?vue&type=template&id=0a65f4ad&scoped=true"
import script from "./StampItemDetails.vue?vue&type=script&lang=js"
export * from "./StampItemDetails.vue?vue&type=script&lang=js"

import "./StampItemDetails.vue?vue&type=style&index=0&id=0a65f4ad&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a65f4ad"]])

export default __exports__